import {Inject, Injectable} from '@angular/core';
import {ApiResponse} from './api-response/api-response.model';
import {BehaviorSubject, Subject} from 'rxjs';
import {HttpContextToken, HttpErrorResponse, HttpRequest, HttpResponse} from "@angular/common/http";
import {AppConfig} from "./app.config";
import {IErrorContext} from "./global-status-handling/server-logger.service";

interface ICacheExpireParams {
  region: 'item' | 'unit' | 'property' | 'itemGroup' | 'classificatorValue' | 'costPriceComponent' | 'classificator' | 'process' | 'resource' | 'unknown';
  id?: string | string[];
  cacheKey: string;
  entities?: string;
}

function assignDefined(target, ...sources) {
  for (const source of sources) {
    if (source) {
      for (const key of Object.keys(source)) {
        const val = source[key];
        if (val !== undefined) {
          target[key] = val;
        }
      }
    }
  }
  return target;
}

export class HttpStatusHandling {
  constructor(init?: Partial<HttpStatusHandling>) {
    assignDefined(this, init);
  }

  status404?: boolean = true;
  status403?: boolean = true;
  status401?: boolean = true;
  status409?: boolean = true;
  status503?: boolean = true;
  status500?: boolean = true;
  status418?: boolean = true;
  status412?: boolean = true;
  clear?: boolean = false;
  GeneralError?: boolean = true;
}

export const HTTP_STATUS_HANDLING = new HttpContextToken<HttpStatusHandling>(() => new HttpStatusHandling());

@Injectable({
  providedIn: 'root'
})
export class MesHttpStatusHandlerService {
  public clear: Subject<boolean>;
  public httpResponse: Subject<HttpResponse<any> | HttpErrorResponse>;
  public httpRequest: Subject<HttpRequest<any>>;
  public httpError: Subject<HttpErrorResponse>;
  public http404: Subject<boolean | ApiResponse<any>>;
  public http401: Subject<boolean | ApiResponse<any>>;
  public http403: Subject<boolean | ApiResponse<any>>;
  public http418: Subject<boolean>;
  public http412: Subject<ApiResponse<any>>;
  public http409: Subject<ApiResponse<any>>;
  public http503: Subject<boolean | ApiResponse<any>>;
  public http500: Subject<ApiResponse<any>>;
  public cacheExpire$: Subject<ICacheExpireParams>;
  public cacheRemove$: Subject<ICacheExpireParams>;
  public urls: BehaviorSubject<string[]> = new BehaviorSubject<string[]>([]);
  public globalError: Subject<IErrorContext>;

  constructor(@Inject('config') private appConfig: AppConfig) {
    this.clear = new Subject<boolean>();
    this.httpResponse = new Subject<any>();
    this.httpRequest = new Subject<any>();
    this.httpError = new Subject<any>();
    this.http404 = new Subject<boolean>();
    this.http401 = new Subject<boolean>();
    this.http403 = new Subject<boolean>();
    this.http409 = new Subject<ApiResponse<any>>();
    this.http418 = new Subject<boolean>();
    this.http412 = new Subject<ApiResponse<any>>();
    this.http503 = new Subject<boolean>();
    this.http500 = new Subject<ApiResponse<any>>();
    this.cacheExpire$ = new Subject<ICacheExpireParams>();
    this.cacheRemove$ = new Subject<ICacheExpireParams>();
    this.globalError = new Subject<IErrorContext>();
  }

  setAppCacheVersion(version: string) {
    if (version) {
      localStorage.setItem(this.getCacheKey(), version);
    } else {
      localStorage.removeItem(this.getCacheKey());
    }
  }

  getAppCacheVersion(): string {
    let item = localStorage.getItem(this.getCacheKey());
    return item ?? '';
  }

  private getCacheKey() {
    return `${this.appConfig.name}:app-cache-version`;
  }
}
